'use client';

import { createStore, StoreSnapshot } from '@xstate/store';

import { CategoryTree } from '@/fo/api/magento';
import type { MappedProduct } from '@/fo/util/map-product-data';

export interface ContextStoreSearchSuggestion {
  query: string;
  products: MappedProduct[];
  categories: CategoryTree[];
  defaultCategories: CategoryTree[];
  defaultProducts: MappedProduct[];
  isLoading: boolean;
}

export const initialContext: ContextStoreSearchSuggestion = {
  query: '',
  products: [],
  categories: [],
  defaultCategories: [],
  defaultProducts: [],
  isLoading: false
};

export const storeSearchSuggestion = createStore({
  context: initialContext,
  on: {
    set: (
      context: ContextStoreSearchSuggestion,
      event: {
        state: Partial<ContextStoreSearchSuggestion>;
      }
    ) => {
      return {
        ...context,
        ...event.state
      };
    },
    setQuery: (
      context: ContextStoreSearchSuggestion,
      event: {
        query: string;
      }
    ) => {
      return {
        ...context,
        query: event.query
      };
    },
    setLoading: (
      context: ContextStoreSearchSuggestion,
      event: {
        isLoading: boolean;
      }
    ) => {
      return {
        ...context,
        isLoading: event.isLoading
      };
    }
  }
});

export const selectQuery = (
  state: StoreSnapshot<ContextStoreSearchSuggestion>
) => state.context.query;
export const selectProducts = (
  state: StoreSnapshot<ContextStoreSearchSuggestion>
) => state.context.products;
export const selectCategories = (
  state: StoreSnapshot<ContextStoreSearchSuggestion>
) => state.context.categories;
export const selectIsLoading = (
  state: StoreSnapshot<ContextStoreSearchSuggestion>
) => state.context.isLoading;
export const selectDefaultProducts = (
  state: StoreSnapshot<ContextStoreSearchSuggestion>
) => state.context.defaultProducts;
export const selectDefaultCategories = (
  state: StoreSnapshot<ContextStoreSearchSuggestion>
) => state.context.defaultCategories;

// storeSearchSuggestion.inspect(console.debug);
